import { isValidEmail } from "./index";

const createStaffError = (code, field) => ({
  __typename: "StaffError",
  code,
  field
});

export const validateCreateStaffForm = formData => {
  const {
    brandId,
    // companyName,
    firstName,
    lastName,
    mallId,
    tenantId,
    contactNo,
    email,
    password,
    selectedPermissionGroup
  } = formData;

  let errors = [];

  if (!selectedPermissionGroup) {
    errors = [...errors, createStaffError("REQUIRED", "permissionGroup")];
  } else {
    // if (
    //   selectedPermissionGroup &&
    //   selectedPermissionGroup.toUpperCase() === "OMI ADMIN"
    // ) {
    //   // Validation for OMI Admin
    //   if (!brandId) {
    //     errors = [...errors, createStaffError("REQUIRED", "brandId")];
    //   }
    // }
    if (
      selectedPermissionGroup &&
      selectedPermissionGroup.toUpperCase() === "SELLER MASTER"
    ) {
      // Validation for Seller Master
      if (!brandId) {
        errors = [...errors, createStaffError("REQUIRED", "brandId")];
      }
      // if (!companyName) {
      //   errors = [...errors, createStaffError("REQUIRED", "companyName")];
      // }
    }
    if (
      selectedPermissionGroup &&
      selectedPermissionGroup.toUpperCase() === "MALL ADMIN"
    ) {
      // Validation for Mall Admin
      if (!mallId) {
        errors = [...errors, createStaffError("REQUIRED", "mallId")];
      }
    }
    if (
      selectedPermissionGroup &&
      selectedPermissionGroup.toUpperCase() === "STORE ADMIN"
    ) {
      // Validation for Store Admin
      if (!brandId) {
        errors = [...errors, createStaffError("REQUIRED", "brandId")];
      }
      if (!tenantId) {
        errors = [...errors, createStaffError("REQUIRED", "tenantId")];
      }
    }
  }

  if (!firstName) {
    errors = [...errors, createStaffError("REQUIRED", "firstName")];
  }

  if (!lastName) {
    errors = [...errors, createStaffError("REQUIRED", "lastName")];
  }

  if (!contactNo) {
    errors = [...errors, createStaffError("REQUIRED", "contactNo")];
  }

  if (!password) {
    errors = [...errors, createStaffError("REQUIRED", "password")];
  }

  if (!email) {
    errors = [...errors, createStaffError("REQUIRED", "email")];
  } else if (!isValidEmail(email)) {
    errors = [...errors, createStaffError("INVALID", "email")];
  }

  return {
    errors,
    isValid: errors.length === 0
  };
};

export const validateUpdateStaffForm = formData => {
  const {
    brandId,
    contactNo,
    email,
    firstName,
    lastName,
    mallId,
    selectedPermissionGroup,
    tenantId
  } = formData;

  let errors = [];

  // if (
  //   selectedPermissionGroup &&
  //   selectedPermissionGroup.toUpperCase() === "OMI ADMIN"
  // ) {
  //   // Validation for OMI Admin
  //   if (!brandId) {
  //     errors = [...errors, createStaffError("REQUIRED", "brandId")];
  //   }
  // }
  if (
    selectedPermissionGroup &&
    selectedPermissionGroup.toUpperCase() === "SELLER MASTER"
  ) {
    // Validation for Seller Master
    if (!brandId) {
      errors = [...errors, createStaffError("REQUIRED", "brandId")];
    }
    // if (!companyName) {
    //   errors = [...errors, createStaffError("REQUIRED", "companyName")];
    // }
  }
  if (
    selectedPermissionGroup &&
    selectedPermissionGroup.toUpperCase() === "MALL ADMIN"
  ) {
    // Validation for Mall Admin
    if (!mallId) {
      errors = [...errors, createStaffError("REQUIRED", "mallId")];
    }
  }
  if (
    selectedPermissionGroup &&
    selectedPermissionGroup.toUpperCase() === "STORE ADMIN"
  ) {
    // Validation for Store Admin
    if (!brandId) {
      errors = [...errors, createStaffError("REQUIRED", "brandId")];
    }
    if (!tenantId) {
      errors = [...errors, createStaffError("REQUIRED", "tenantId")];
    }
  }

  if (!firstName) {
    errors = [...errors, createStaffError("REQUIRED", "firstName")];
  }

  if (!lastName) {
    errors = [...errors, createStaffError("REQUIRED", "lastName")];
  }

  if (!contactNo) {
    errors = [...errors, createStaffError("REQUIRED", "contactNo")];
  }

  if (!email) {
    errors = [...errors, createStaffError("REQUIRED", "email")];
  } else if (!isValidEmail(email)) {
    errors = [...errors, createStaffError("INVALID", "email")];
  }

  return {
    errors,
    isValid: errors.length === 0
  };
};
